module.exports = __webpack_public_path__ + "assets/img/authented.f5f8a48e.png";